import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "../styles/Hero.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <section className="hero">
      {/* Floating blobs */}
      <div className="blob blob1"></div>
      <div className="blob blob2"></div>
      <div className="blob blob3"></div>
      {/* Hero content */}
      <div className="hero-content">
        <div className="hero-left">
          <h1 className="hero-title">
            Welcome to <span>CVEY Solutions</span>
          </h1>
          <p className="hero-subtitle">Your way to smarter solutions</p>
        </div>

        <div className="hero-right">
          <div className="highlight-banner">
            <span>Quantum Computing Training for UG Students</span>
          </div>
          <Slider {...sliderSettings} className="hero-carousel">
            <div className="hero-card ugc-card">
              <h2 className="card-title">Register For Internship</h2>
              <p className="card-subtitle">Stipend Intern | Paid intern</p>
              <Link to="/register">
                <button className="hero-btn">
                  Register
                </button>
              </Link>

            </div>

            <div className="hero-card research-card">
              <h2 className="card-title">Research Consultancy</h2>
              <p className="card-subtitle">Book an appointment for research guidance</p>
              <Link to="/appointment/research">
                <button className="hero-btn">Appointment</button>
              </Link>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Hero;